export default {"src":"/_next/static/media/feature-2.ddefed29.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};